import gql from 'graphql-tag';

export default gql`
  mutation updateStoreBasicInfo($input: UpdateStoreBasicInfoInput!) {
    updateStoreBasicInfo(input: $input) {
      success
      userErrors {
        field
        message
      }
    }
  }
`;
